import React from 'react'
import { useStaticQuery, graphql } from "gatsby"
import Img from 'gatsby-image'
import { withStyles } from "@material-ui/core"
import PropTypes from "prop-types"

const style = theme => ({
  image: {
    width: '178px',
    height: '598px',
    [theme.breakpoints.down('sm')]: {
      transform: 'rotate(-90deg) rotateY(180deg)',
      marginLeft: '211px',
      marginTop: '-209px',
    }
  }
})

const ImageProduct = ({ imageInfo, imageAlt, horizontal = false, classes }) => {
  const data = useStaticQuery(graphql`
    query HeaderQuery {
      classMarkImageDefault: file(relativePath: { eq: "cables/noCableImage.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 220) {
          ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  let keyWords = ' купить, цена, вес, диаметр, характеристики'

  let ImageData
  if (!imageInfo) {
    ImageData = data.classMarkImageDefault.childImageSharp.fluid
  }
  else {
    ImageData = imageInfo.childImageSharp.fluid
  }

  return (
      <Img className={classes.image} alt={imageAlt+keyWords} fluid={ImageData}/>
  )

}

ImageProduct.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(style)(ImageProduct)